export default __webpack_public_path__ + "static/media/mstc-landing-3.efc8b699.png";